module.exports = __webpack_public_path__ + "static/img/after_sale_columba.16ab7f64.png";